import Menu from '../../menu/menu'
import * as s from './style'


function ContainerLeft(){
    return(
        <s.container tabIndex={1} title='menu' >
            <img className='logo-100pay' alt='100Pay – Soluções em Pagamentos' src='https://www.100pay.com.br/wp-content/uploads/2021/06/LOGO-100PAY-VETOR.png' />
            <Menu/>
            <div className='logo-sifrapag'>
                <img alt='Sifrapag – Transparência em pagamentos!' src='https://www.sifrapag.com.br/novosite/wp-content/uploads/2020/03/logo-sifra-pag-1.png' />
            </div>
        </s.container>
    )
}

export default ContainerLeft